import { AccordionAnimation } from "@components/Accordion/AccordionAnimation";
import Container from "@components/Atomic/Container/Container";
import { StyledContainer } from "@components/Styled/Container";
import { clsx } from "clsx";
import React from "react";
import { withAccordion } from "./withAccordion";

import { IconPlus, IconMinus } from "@bared/ui";

const InnerContainer = (props: any) => (
  <StyledContainer {...props} className={clsx(props.className, "flex")} />
);
const Sections = (props: any) => (
  <div {...props} className={clsx(props.className, "mx-auto max-w-md")} />
);
const Wrapper = (props: any) => (
  <div
    {...props}
    className={clsx(props.className, "border-b border-primary")}
  />
);

const Title = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "flex cursor-pointer flex-row items-center justify-between py-mini text-body leading-h2",
      props.active ? "font-medium" : "font-normal",
    )}
  />
);

const Accordion = withAccordion(({ contents, active, handleClick, styles }) => {
  return (
    <Container styles={styles} data-component-type="section-accordion">
      <InnerContainer>
        <Sections>
          {contents?.map((content, index) => (
            <Wrapper key={content.title}>
              <Title active={index === active} onClick={handleClick(index)}>
                <p>{content.title}</p>
                {index !== active ? (
                  <IconPlus className="w-[16px]" />
                ) : (
                  <IconMinus className="w-[16px]" />
                )}
              </Title>
              <AccordionAnimation active={index === active}>
                <div className={"rte"}>{content.content}</div>
              </AccordionAnimation>
            </Wrapper>
          ))}
        </Sections>
      </InnerContainer>
    </Container>
  );
});

export default Accordion;
